/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Container/Container.ts" />
namespace HA.Core.Controller.Menu {
    import MenuGridTag = HA.Core.HTML.Container;

    export class Menu extends Controller {

        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.addToData("tag", new MenuGridTag(toMap(data)));
            this.initializeItems();
        }

        protected initializeItems() {
            this.addToData("itemControllers", new Map());
            const items = this.getItems();
            if (items) {
                const me = this;
                items.forEach( (item: any) => {
                    me.addItem(toMap(item));
                });
            }
        }

        /**
         *
         * @param data
         */
        protected addItem(data: Map<any, any>) {
            const config = toMap(data);
            config.set("services", this.getItemService());
            config.set("pelement", this.get("tag"));
            this.getItemControllers().set(data.get("id"), this.createItemController(config));
        }

        /**
         *
         * @param data
         * @returns {any}
         */
        protected createItemController(data: Map<any, any>) {
            if (data.has("controllerName")) {
                return createService(HA.Core.Controller.Menu, data.get("controllerName"), data);
            }

            return new MenuItem(data);
        }

        protected getItemService() {
            return this.get("services");
        }

        /**
         *
         * @returns {Map}
         */
        protected getItemControllers() {
            return this.get("itemControllers");
        }

        /**
         *
         * @returns {Map}
         */
        protected getItems() {
            return this.get("items");
        }
    }
}
